import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SuccessPage from './pages/SuccessPage';
import CardView from './pages/CardView';

function App() {
  return (
    <Router>
      <Routes>
        {/* The Landing Page (at yourwebsite.com/) */}
        <Route path="/" element={<LandingPage />} />

        {/* The Success Page (after payment) */}
        <Route path="/success" element={<SuccessPage />} />

        {/* The Actual Card (the link shared with the valentine) */}
        <Route path="/v/:cardId" element={<CardView />} />
      </Routes>
    </Router>
  );
}

export default App;